import {request} from "@/api/request.js";

const analysis2={
    getAnalysis2(chromosomalRegions){
        return request.get(
            "/analysis2_distal",
            {
                chromosomalRegions: chromosomalRegions,
            }
        )
    },
    getSampleInfo3D(sample){
        return request.get(
            "/analysis2/SampleInfo3D",
            {
                sample: sample,
            }
        )
    },
    getAnalysis2SNV(snv){
        return request.get(
            "/analysis2_distal_snv",
            {
                snv: snv,
            }
        )
    },
    getDistal(snv,tissue,pageNum,pageSize){
        return request.get(
            "/analysis2/getDiatal",
            {
                snvList: snv,
                pageNum:1,
                pageSize:10000000,
                tissue
            }
        )
    },
    getProximal(snv,pageNum,pageSize,tissue){
        return request.get(
            "/analysis2/getProximal",
            {
                snvList: snv,
                pageNum:1,
                pageSize:10000000,
                tissue
            }
        )
    },
    getAnalysis(chromosomalRegions){
        return request.get(
            "/analysis2/analysis",
            {
                chromosomalRegions: chromosomalRegions,
            }
        )
    }
}

export default analysis2;
